<template>
	<div>
		<!-- Floating Button -->
		<v-btn
			ref="floatingButton"
			fab
			fixed
			right
			small
			style="top: 25%; z-index: 1000;"
			color="primary"
			@click="togglePopup"
		>
			<v-icon>info</v-icon>
		</v-btn>

		<!-- AI Data Popup -->
		<div v-if="showPopup" ref="popup" class="ai-data-popup" :style="popupStyle">
			<v-card max-width="550px" class="popup-card">
				<v-card-title class="pa-3 primary white--text">
					<v-icon class="mr-2" color="white">smart_toy</v-icon>
					<span class="subtitle-1 font-weight-bold">AI Data Information</span>
				</v-card-title>

				<v-card-text class="pa-0">
					<div v-if="aiFlags.length === 0 && aiRemarks.length === 0">
						<div class="pa-4 text-center">
							<v-icon size="48" color="grey lighten-1" class="mb-2">info_outline</v-icon>
							<p class="mb-0 grey--text">No AI data available for this file.</p>
						</div>
					</div>
					<div v-else>
						<!-- Boolean Flags Section -->
						<div v-if="aiFlags.length > 0" class="flags-section">
							<div class="section-header">
								<v-icon class="mr-2" color="primary">flag</v-icon>
								<span class="font-weight-bold">AI Predictions</span>
							</div>
							<div class="flags-grid">
								<div v-for="(flag, index) in aiFlags" :key="index" class="flag-item">
									<div class="flag-label">{{ formatFlagName(flag.key) }}</div>
									<v-chip 
										:color="flag.value ? 'success' : 'error'" 
										:text-color="flag.value ? 'white' : 'white'"
										small
										dark
									>
										<v-icon small class="mr-1">{{ flag.value ? 'check_circle' : 'cancel' }}</v-icon>
										{{ flag.value ? 'Yes' : 'No' }}
									</v-chip>
								</div>
							</div>
						</div>

						<!-- Remarks Section -->
						<div v-if="aiRemarks.length > 0" class="remarks-section">
							<div class="section-header">
								<v-icon class="mr-2" color="orange darken-2">comment</v-icon>
								<span class="font-weight-bold">AI Remarks & Additional Data</span>
							</div>
							<div class="remarks-content">
								<div v-for="(remark, index) in aiRemarks" :key="index" class="remark-item">
									<div class="remark-label">
										<v-icon small class="mr-1" color="grey darken-1">label</v-icon>
										{{ formatFlagName(remark.key) }}
									</div>
									<div class="remark-value">
										{{ remark.value || 'N/A' }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</div>

		<!-- Overlay to close popup when clicking outside -->
		<div
			v-if="showPopup"
			class="popup-overlay"
			@click="showPopup = false"
		></div>
	</div>
</template>

<script>
export default {
	name: 'AIDataPopup',
	props: {
		selectedFile: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			showPopup: false,
			popupStyle: {},
			popupHeight: 700,
		};
	},
	computed: {
		aiData() {
			if (!this.selectedFile) return [];

			const aiKeys = Object.keys(this.selectedFile).filter(key =>
				key.startsWith('AI')
			);

			return aiKeys.map(key => ({
				key: key,
				value: this.selectedFile[key],
			}));
		},
		aiFlags() {
			if (!this.selectedFile) return [];

			const aiKeys = Object.keys(this.selectedFile).filter(key =>
				key.startsWith('AI') && typeof this.selectedFile[key] === 'boolean'
			);

			return aiKeys.map(key => ({
				key: key,
				value: this.selectedFile[key],
			}));
		},
		aiRemarks() {
			if (!this.selectedFile) return [];

			const aiKeys = Object.keys(this.selectedFile).filter(key =>
				key.startsWith('AI') && typeof this.selectedFile[key] !== 'boolean'
			);

			return aiKeys.map(key => ({
				key: key,
				value: this.selectedFile[key],
			}));
		},
	},
	methods: {
		togglePopup() {
			this.showPopup = !this.showPopup;
			if (this.showPopup) {
				this.$nextTick(() => {
					this.calculatePopupPosition();
				});
			}
		},
		calculatePopupPosition() {
			if (!this.$refs.floatingButton || !this.$refs.popup) return;

			const button = this.$refs.floatingButton.$el;
			const popup = this.$refs.popup;
			const buttonRect = button.getBoundingClientRect();
			const popupRect = popup.getBoundingClientRect();
			const windowHeight = window.innerHeight;
			const windowWidth = window.innerWidth;

			let top = buttonRect.bottom - 8;
			let left = buttonRect.left - popupRect.width;

			const popupBottom = top + popupRect.height;
			console.log(popupBottom, 'popupBottom');
			console.log(windowHeight, 'windowHeight');
			if (popupBottom > windowHeight) {
				const overflow = popupBottom - windowHeight;
				console.log(overflow, 'overflow');

				top = buttonRect.top - overflow;
				left -= 4;
			}

			this.popupStyle = {
				position: 'fixed',
				top: `${top}px`,
				left: `${left}px`,
				zIndex: 1001,
			};
		},
		formatFlagName(key) {
			// Convert AI field names to more readable format
			// e.g., 'AI_is_valid_email' -> 'Is Valid Email'
			return key
				.replace(/^AI_?/i, '') // Remove AI prefix
				.replace(/_/g, ' ') // Replace underscores with spaces
				.replace(/\b\w/g, l => l.toUpperCase()); // Capitalize each word
		},
	},
	mounted() {
		// console.log(this.showPopup)
		// this.calculatePopupPosition();
		window.addEventListener('resize', () => {
			if (this.showPopup) {
				this.$nextTick(() => {
					this.calculatePopupPosition();
				});
			}
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.calculatePopupPosition);
	},
	watch: {
		showPopup(nv, ov) {
			console.log(nv, ov);
			this.$nextTick(() => {
				this.calculatePopupPosition();
			});
		},
	},
};
</script>

<style scoped>
.ai-data-popup {
	position: fixed;
	z-index: 1001;
	max-height: 80vh;
	overflow-y: auto;
}

.popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: transparent;
	z-index: 1000;
}

/* Section styling */
.flags-section {
	padding: 12px;
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
	border-bottom: 1px solid #e0e0e0;
}

.remarks-section {
	padding: 12px;
	background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
	border-radius: 0 0 4px 4px;
}

.section-header {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
	padding-bottom: 6px;
	border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}

.section-header span {
	font-size: 14px;
	color: #424242;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

/* Flags grid styling */
.flags-grid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 8px;
	margin-top: 6px;
}

.flag-item {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 8px;
	background: rgba(255, 255, 255, 0.8);
	border-radius: 6px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.flag-item:hover {
	transform: translateY(-1px);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.flag-label {
	font-size: 11px;
	font-weight: 600;
	color: #616161;
	margin-bottom: 4px;
	text-transform: capitalize;
	line-height: 1.2;
	word-break: break-word;
}

/* Remarks styling */
.remarks-content {
	margin-top: 6px;
}

.remark-item {
	padding: 8px;
	margin-bottom: 6px;
	background: rgba(255, 255, 255, 0.9);
	border-radius: 6px;
	border-left: 4px solid #ff9800;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.remark-item:hover {
	transform: translateX(2px);
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.remark-item:last-child {
	margin-bottom: 0;
}

.remark-label {
	display: flex;
	align-items: center;
	font-size: 12px;
	font-weight: 600;
	color: #424242;
	margin-bottom: 4px;
	text-transform: capitalize;
}

.remark-value {
	font-size: 13px;
	color: #616161;
	line-height: 1.3;
	word-break: break-word;
	padding: 6px;
	background: rgba(0, 0, 0, 0.03);
	border-radius: 4px;
	font-family: 'Roboto Mono', monospace;
}

/* Custom chip styling for better visibility */
.v-chip.v-chip--small {
	height: 24px !important;
	font-size: 11px !important;
	font-weight: 600 !important;
	letter-spacing: 0.3px !important;
}

/* Custom popup shadow */
.popup-card {
	box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12), 0 6px 20px rgba(0, 0, 0, 0.15), 0 2px 10px rgba(0, 0, 0, 0.1) !important;
	border-radius: 12px !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
	.flags-grid {
		grid-template-columns: 1fr 1fr;
	}
}

@media (max-width: 480px) {
	.flags-grid {
		grid-template-columns: 1fr;
	}
	
	.ai-data-popup {
		max-width: 90vw !important;
	}
	
	.popup-card {
		max-width: 90vw !important;
	}
}

/* Enhanced card styling */
.v-card {
	border-radius: 12px !important;
	overflow: hidden;
}

.v-card__title {
	background: linear-gradient(45deg, #1976d2, #42a5f5) !important;
}

/* Smooth animations */
.flag-item, .remark-item {
	transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Custom scrollbar */
.ai-data-popup::-webkit-scrollbar {
	width: 6px;
}

.ai-data-popup::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 3px;
}

.ai-data-popup::-webkit-scrollbar-thumb {
	background: #c1c1c1;
	border-radius: 3px;
}

.ai-data-popup::-webkit-scrollbar-thumb:hover {
	background: #a8a8a8;
}
</style>
